import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS, waLink } from "../../data/content";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 bg-[#0A0614]">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal>
        <span className="text-xs uppercase tracking-[0.3em] text-[#C5A059]">Preguntas frecuentes</span>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl md:text-6xl text-[#F3EFE7] tracking-tight">
          Lo que sueles preguntarme
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}
              className="border-b border-white/10">
              <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-[#F3EFE7] hover:text-[#C5A059] hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="mt-10 text-white/70">
          ¿Tienes otra duda?{" "}
          <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="faq-whatsapp"
            className="text-[#C5A059] underline underline-offset-4 hover:text-[#D4AF37] transition-colors">
            Pregúntame por WhatsApp
          </a>.
        </p>
      </Reveal>
    </div>
  </section>
);
